<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0001 1.83325L12.6667 3.16659M7.59339 8.23992L10.3334 5.49992M10.3334 5.49992L12.3334 7.49992L14.6667 5.16659L12.6667 3.16659M10.3334 5.49992L12.6667 3.16659M7.59339 8.23992C7.93762 8.57956 8.21126 8.98394 8.39856 9.42978C8.58587 9.87561 8.68313 10.3541 8.68475 10.8377C8.68637 11.3213 8.59231 11.8004 8.408 12.2475C8.22369 12.6945 7.95277 13.1007 7.61082 13.4427C7.26888 13.7846 6.86268 14.0556 6.4156 14.2399C5.96852 14.4242 5.48939 14.5182 5.00582 14.5166C4.52224 14.515 4.04376 14.4177 3.59792 14.2304C3.15209 14.0431 2.74771 13.7695 2.40806 13.4253C1.74015 12.7337 1.37057 11.8075 1.37892 10.8461C1.38728 9.88473 1.7729 8.96508 2.45273 8.28525C3.13256 7.60542 4.0522 7.2198 5.01359 7.21145C5.97498 7.20309 6.90119 7.57267 7.59273 8.24059L7.59339 8.23992Z"
      stroke="#4C4C60"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
